<template>
    <div class="container-fluid mt-6 px-5">
        <div id="lower-div" class="row mt-3">
            <div class="card mb-4">
                <div v-loading="loading">
                    <div class="p-2" m="4">
                        <div class="card-body px-0 pt-0 pb-3">
                            <titles text="Cari subroqasiya işləri" />
                            <hr style="margin-top:0;margin-bottom: 15px;" />
                            <div class="filter-section mb-3">
                                <div class="row g-3 align-items-end">
                                    <div class="col-md-2">
                                        <label class="form-label">Tarixdən</label>
                                        <el-date-picker v-model="dateFrom" size="large" type="date"
                                            placeholder="Seçin" format="DD.MM.YYYY" value-format="YYYY-MM-DD"
                                            style="width: 100%" />
                                    </div>
                                    <div class="col-md-2">
                                        <label class="form-label">Tarixədək</label>
                                        <el-date-picker v-model="dateTo" size="large" type="date"
                                            placeholder="Seçin" format="DD.MM.YYYY" value-format="YYYY-MM-DD"
                                            style="width: 100%" />
                                    </div>
                                    <div class="col-md-2">
                                        <label class="form-label">Mərhələ</label>
                                        <el-select v-model="stage" size="large" placeholder="Seçin"
                                            style="width: 100%">
                                            <el-option v-for="item in stageOptions" :key="item.value"
                                                :label="item.label" :value="item.value" />
                                        </el-select>
                                    </div>
                                    <div class="col-md-3 d-flex align-items-end">
                                        <soft-button type="button" @click="applyFilters">
                                            <i class="fas fa-search"></i> Axtar
                                        </soft-button>
                                        <soft-button type="button" variant="outline" color="secondary" class="ms-2"
                                            @click="toggleAdvanced">
                                            <i class="fas fa-filter"></i>
                                        </soft-button>
                                    </div>
                                </div>
                            </div>

                            <transition name="fade-slide">
                                <div v-if="showAdvanced" class="advanced-filter-section mb-3">
                                    <div class="row g-3">
                                        <div class="col-md-2">
                                            <label class="form-label">Axtarış növü</label>
                                            <el-select v-model="searchType" size="large" placeholder="Hamısı"
                                                style="width: 100%" clearable @change="onSearchTypeChange">
                                                <el-option label="Hamısı" :value="0" />
                                                <el-option label="Məsul şəxs" :value="1" />
                                                <el-option label="Cavabdeh" :value="2" />
                                                <el-option label="Sığorta növü" :value="3" />
                                                <el-option label="Şəhadətnamə №" :value="4" />
                                            </el-select>
                                        </div>
                                        <div class="col-md-3 d-flex align-items-end">
                                            <el-input v-if="searchType && searchType !== 0" v-model="searchText"
                                                size="large" placeholder="Axtar" style="width: 100%;" clearable
                                                @keyup.enter="applyFilters"/>
                                        </div>
                                    </div>
                                </div>
                            </transition>

                            <approved-subrogations-table :data="approvedSubrogations"
                                :pagination="{ page, pageSize, total }" @page-change="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Titles from '@/project/Components/Titles.vue';
import { GetApprovedSubrogations } from '@/project/Source/subrogations';
import ApprovedSubrogationsTable from '@/project/Subrogations/Components/Tables/ApprovedSubrogationsTable.vue';
import SoftButton from "@/components/SoftButton.vue";

export default {
    components: {
        Titles,
        SoftButton,
        ApprovedSubrogationsTable
    },
    data() {
        const today = new Date();
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        const formatDate = (date) => date.toISOString().split('T')[0];

        return {
            approvedSubrogations: [],
            loading: false,
            dateFrom: formatDate(threeMonthsAgo),
            dateTo: formatDate(today),
            stage: 0,
            searchType: 0,
            searchText: '',
            showAdvanced: false,
            stageOptions: [
                { value: 0, label: 'Hamısı' },
                { value: 2, label: 'İlkin mərhələ' },
                { value: 3, label: 'Məhkəməyə hazırlıq' },
                { value: 4, label: 'Məhkəmə' },
                { value: 5, label: 'İcra' },
            ],
            page: 1,
            pageSize: 20,
            total: 0
        };
    },
    mounted() {
        const query = this.$route.query;

        if (query.searchType !== undefined) {
            this.searchType = +query.searchType;
            this.showAdvanced = true;
        }

        if (query.searchText) {
            this.searchText = query.searchText;
            this.showAdvanced = true;
        }

        const todayStr = new Date().toISOString().split('T')[0];
        const defaultFrom = this.dateFrom; // из data()
        const defaultTo = this.dateTo;

        if (query.searchType && query.searchText && (!query.dateFrom || query.dateFrom === 'null' || query.dateFrom === '')) {
            this.dateFrom = '1900-01-01';
            this.dateTo = todayStr;
        } else {
            this.dateFrom = (query.dateFrom && query.dateFrom !== 'null' && query.dateFrom !== '') ? query.dateFrom : defaultFrom;
            this.dateTo = (query.dateTo && query.dateTo !== 'null' && query.dateTo !== '') ? query.dateTo : defaultTo;
        }

        this.fetchApprovedSubrogations();
    },
    methods: {
        fetchApprovedSubrogations() {
            this.loading = true;

            const searchType = this.searchType && this.searchType !== 0 ? this.searchType : 0;
            const searchText = this.searchText?.trim() ? this.searchText : null;

            const todayStr = new Date().toISOString().split('T')[0];
            const safeDateFrom = this.dateFrom ? this.dateFrom : '1900-01-01';
            const safeDateTo = this.dateTo ? this.dateTo : todayStr;

            const params = {
                dateFrom: safeDateFrom,
                dateTo: safeDateTo,
                stage: this.stage,
                searchType,
                searchText,
                page: this.page,
                pageSize: this.pageSize
            };

            GetApprovedSubrogations(params)
                .then(res => {
                    const arr = res.data.data ?? res;
                    if (Array.isArray(arr) && arr.length > 0 && arr[0].total !== undefined) {
                        this.approvedSubrogations = arr;
                        this.total = arr[0].total;
                    } else {
                        this.approvedSubrogations = arr.items ?? arr;
                        this.total = arr.total ?? 0;
                    }
                })
                .catch(err => {
                    console.error("Failed to load:", err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        applyFilters() {
            this.page = 1;
            this.fetchApprovedSubrogations();
        },
        toggleAdvanced() {
            this.showAdvanced = !this.showAdvanced;
        },
        onSearchTypeChange() {
            this.searchText = '';
        },
        onPageChange(newPage) {
            this.page = newPage;
            this.fetchApprovedSubrogations();
        }
    }
};
</script>

<style scoped>
.advanced-filter-section {
    margin-top: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s cubic-bezier(.4, 0, .2, 1);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-16px) scaleY(0.96);
}

.form-label {
    font-weight: 600;
    margin-bottom: 5px;
}

.el-button {
    margin-bottom: 5px;
}
</style>
